module.exports = __webpack_public_path__ + "static/media/1009824.335eddd4.jpg";